export default __webpack_public_path__ + "static/media/photo7.482a566c.jpg";